import { render, staticRenderFns } from "./ItemMaster.vue?vue&type=template&id=2e89cda2&"
import script from "./ItemMaster.vue?vue&type=script&lang=js&"
export * from "./ItemMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports